import { searchSessionEnded, suggestionSelected } from 'owa-search';
import { FileSuggestion } from 'owa-search-service';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
import isFileSuggestionsSearchAction from '../utils/isFileSuggestionsSearchAction';

/* Set the suggestion in the store when selected so it can be retrieved */
mutator(suggestionSelected, actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    if (!isFileSuggestionsSearchAction(scenarioId)) {
        return;
    }
    const suggestion = actionMessage.suggestion;
    const store = getStore();
    store.suggestion = <FileSuggestion>suggestion;
});

/* Reset suggestion in the store when the search session is ended */
mutator(searchSessionEnded, actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    if (!isFileSuggestionsSearchAction(scenarioId)) {
        return;
    }

    const store = getStore();
    store.suggestion = null;
});
